// The left column of «Файлы» (R-M2, um/2026-10-30/03 п.1): «Все файлы» and the sections the files belong to, with their counts — the
// filter by section that was a dropdown above the table, now in the frame's standard column.

import { navigate, useLocation } from '../shell/router.ts';
import { Branches, NavRow } from '../shell/SideNav.tsx';
import { NONE, sectionsOf, useFiles } from './files-index.ts';
import sh from '../shell/shell.module.css';

const href = (section: string) => (section ? `/s/files?section=${encodeURIComponent(section)}` : '/s/files');

export function FilesNav() {
  const { rows } = useFiles();
  const { path, search } = useLocation();
  const here = path === '/s/files';
  const cur = search.get('section') ?? '';
  const all = rows ?? [];
  const count = (n: number) => <span className={sh.navCount}>{n.toLocaleString('ru-RU')}</span>;
  return (
    <div className={sh.navNode}>
      <NavRow icon="download" label="Все файлы" on={here && !cur} count={rows ? count(all.length) : undefined} onClick={() => navigate(href(''))} />
      {!!all.length && (
        <Branches>
          {sectionsOf(all).map((x) => (
            <NavRow key={x} label={x === NONE ? 'Без записи' : x} on={here && cur === x} count={count(all.filter((r) => (r.typeName || NONE) === x).length)} onClick={() => navigate(href(x))} />
          ))}
        </Branches>
      )}
    </div>
  );
}

export function useFilesTitle(): string | null {
  const { path, search } = useLocation();
  if (path !== '/s/files') return null;
  const cur = search.get('section');
  return cur ? (cur === NONE ? 'Без записи' : cur) : 'Все файлы';
}
